import Vue from 'vue'
import axios from 'axios'
import momentFormat from './mixins/momentFormat'
import imagesLoaded from 'vue-images-loaded'
import { apiEnv, startDate, endDate} from './env.js'
import {bindPageTopLinks} from './scroll'

// 「↑このページの先頭へ」リンクを有効にする
bindPageTopLinks()

var apiPath = apiEnv()
new Vue({
  el: '#Guest',
  mixins: [momentFormat],
  data: {
    guests: [],
    dates:[],
    filter: {
      //order_by: 'act_date',
      posts_per_page: 99999
    }
  },
  directives: {
    imagesLoaded
  },
  created () {
    for (var i = 0; i <= this.daysDiff(startDate, endDate); i++) {
      this.dates.push(this.addDatetime(startDate, i))
    }
    var params = this.filter
    axios.get(apiPath + '/acts/search', { params }).then((res) => {
      this.guests = res.data.data
    })
  },
  mounted () {
    window.scrollTo({
      top: 0
    })
  },
  methods: {
    imageLoaded () {
      if (location.hash) {
        var urlHash = location.hash.replace('#', '')
        window.setTimeout(() => {
          window.scrollTo({
            top: document.getElementById(urlHash).getBoundingClientRect().top + window.pageYOffset
          })
        }, 200 )
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/guest.js